module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6012HD_white-64119cb0dbf975535e99664e57a9920a.png";